export const BNK_STMT_updateFlowTypeEnumReducer = {
  BNK_STMT_updateFlowTypeEnum: (state, action) => {
    state.flowTypeEnum = action.payload;
  },
};
